<template>
  <div class="content OverviewOrderView">
    <div
      class="container-fluid"
      :class="{
        'disable-ske': !loading,
      }"
    >
      <div class="d-flex justify-content-between flex-lg-row flex-wrap details-wrapper">
        <div class="sub-col">
          <card class="mb-0">
            <h4 class="card-title p-2">
              Bestelling
            </h4>

            <GeneralDetails
              :vuelidate="$v"
              :disabled="!canBeEdited"
              :editing="true"
              :showRemark="true"
              :loading="loading"
            />
          </card>
        </div>
        <div class="sub-col">
          <card class="mb-0">
            <h4 class="card-title p-2">
              Klantgegevens
            </h4>

            <CustomerDetails
              :vuelidate="$v.customerDetails"
              :wholesale="true"
              :disabled="!canBeEdited"
            />
          </card>
        </div>
      </div>

      <ComposableTable class="border rounded mt-2"
        :data="orders"
        :loading="loading"
        :columns="columns"
        :variables="variables"
        :page-size="20"
      >
        <template v-if="canBeEdited" #cell-price="{item}">
          <EditableTableItem
            :value="item.price"
            @save="price => updateOrder(item.sku, { price })"
          >
            {{ item.price }}
          </EditableTableItem>
        </template>
        <template v-if="canBeEdited" #cell-qty="{item}">
          <EditableTableItem
            :value="item.qty"
            @save="qty => updateOrder(item.sku, { qty })"
          >
            {{ item.qty }}
          </EditableTableItem>
        </template>
        <template v-if="canBeEdited" #before-first-row>
          <TableRowAction
            message="Add product to order"
            :showAlways="true"
            @close="productSelected = []"
            @open="openCheckboxOptions"
          >
            <div class="p-2">
              <CheckboxOptions
                :selected.sync="productSelected"
                :resetWhenClose="true"

                endpoint="/api/products"
                uid="sku"
                searchQuery="search"
                :params="params"

                ref="table-row-action"
              >
                Select products

                <template v-if="productSelected.length" #end-of-list>
                  <div class="d-flex">
                    <button class="mx-2 btn btn-primary flex-grow-1" @click="saveSelected">
                      Opslaan
                    </button>
                  </div>
                </template>
              </CheckboxOptions>
            </div>
          </TableRowAction>
        </template>

        <template v-if="canBeEdited" #row-action="{item}">
          <div class="delete-icon" @click="removeProductFromOrder(item)">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
        </template>
      </ComposableTable>

      <div class="d-flex justify-content-between mt-2">
        <span class="ske">
          <button type="button" class="btn btn-secondary" id="go-back" data-dismiss="modal" @click="goBack">
            Terug
          </button>
        </span>
        <span v-if="canBeEdited" class="ske">
          <button type="button" class="btn btn-primary" id="submit-button" @click="save">
            Opslaan
          </button>
        </span>
        <span v-if="!isInvoice && isAdmin" class="ske">
          <button type="button" class="btn btn-primary" id="submit-button" @click="sendToInvoice">
            Factuur
          </button>
        </span>
        <span v-else-if="isInvoice && isAdmin" class="ske">
          <button type="button" class="btn btn-primary" id="submit-button" @click="deleteInvoice">
            Factuur verwijderen
          </button>
        </span>
        <span v-else-if="isInvoice && !isAdmin"></span>
      </div>
    </div>
  </div>
</template>

<script>

import OrderItem from "./OrderItem.vue"
import FormInput from "/src/components/Inputs/FormInput.vue"
import Carousel from "../../layout/Carousel.vue"
import GeneralDetails from "../../components/OrderForms/GeneralDetails.vue"
import CustomerDetails from "./CustomerDetails.vue"
import ComposableTable from "../../components/Product/ComposableTable/ComposableTable.vue"
import TableRowAction from "../../layout/TableComposables/TableRowAction.vue"
import CheckboxOptions from "../../layout/Table/DropdownCheckboxTableFilters/CheckboxOptions.vue"
import EditableTableItem from "../../layout/EditTableItem/EditableTableItem.vue";

import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"

const placeholder = {
  name: "qui",
  price: "978.00",
  qty: 3,
  sku: "tempore",
}

const fields = [
  "site", "orderNumber", "orderDate", "orders", "remark"
]

const customerDetails = [
  "firstName", "lastName", "street", "houseNumber", "houseNumberExtension", "postalCode", "city", "countryCode", "telephone", "email", "vatId", "iban", "companyName", "shopName"
]

export default {
  metaInfo() {
    const order = this.order

    return {
      title: order ? `${order.site} - Order` : "Order Informatie"
    }
  },
  components: {
    ComposableTable,
    TableRowAction,
    EditableTableItem,
    CustomerDetails,
    FormInput,
    GeneralDetails,
    OrderItem,
    EmptyStatePlaceholder,
    CheckboxOptions,
    Carousel,
  },
  data() {
    return {
      state: null,
      order: null,
      loading: true,

      orders: [],
      productSelected: [],
      orderImages: {},
      placeholder,

      ...fields.reduce((obj, key) => ({
        ...obj,
        [key]: "",
      }), {}),

      customerDetails: {
        ...customerDetails.reduce((obj, key) => ({
          ...obj,
          [key]: "",
        }), {}),
      },
    }
  },
  validations: {
    ...fields.reduce((obj, key) => ({
      ...obj,
      [key]: {},
    }), {}),

    customerDetails: {
      ...customerDetails.reduce((obj, key) => ({
        ...obj,
        [key]: {},
      }), {}),
    },
  },
  async created() {
    this.load()
  },
  methods: {
    updateOrder(sku, data) {
      const index = this.orders.findIndex(order => order.sku === sku)
      if (index > -1) {
        this.orders.splice(index, 1, {...this.orders[index], ...data})
      }
    },
    saveSelected() {
      const products = this.productSelected.map(item => ({ sku: item.sku, name: item.name, qty: 1, price: item.price }))
      products.forEach(item => {
        if (!this.orders.some(order => order.sku === item.sku)) {
          this.orders.push(item)
        }
      })
      this.$refs["table-row-action"].close()
    },
    openCheckboxOptions() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.$refs["table-row-action"].open()
        })
      })
    },
    goBack() {
      this.$router.push("/admin/wholesale-orders").catch(()=>{})
    },
    async removeProductFromOrder({sku}) {
      const index = this.orders.findIndex(order => order.sku === sku)
      if (index > -1) {
        this.orders.splice(index, 1)
      }
    },
    async load() {
      this.loading = true

      const order = (await this.axios.get(`/api/wholesale/orders/${this.id}`)).data
      if (order) {
        this.orders = order.orders
        this.orders.forEach(o => {
          if (o.colli) {
            o.boxes = Math.floor(o.qty / o.colli)
            const pieces = o.qty % o.colli
            if (pieces > 0) {
              if(o.boxes > 0) {
                o.boxes += ` en ${pieces} losse stuk` + (pieces > 1 ? 's' : '')
              } else {
                o.boxes = `geen, alleen ${pieces} losse stuk` + (pieces > 1 ? 's' : '')
              }
            }
          } else {
            o.colli = "-"
            o.boxes = "-"
          }
        })
        this.state = order.state

        fields.forEach(key => this.$v[key].$model = order[key])
        if (order.customerDetails && this.$v.customerDetails) {
          customerDetails.forEach(key => this.$v.customerDetails[key].$model = order.customerDetails[key])
        } else {
          this.$v.remark.$model = order.remark
        }
      }
      this.order = order

      this.loading = false
    },
    async sendToInvoice() {
      await this.$handlePromise(async () => {
        const details = {...this.orderDetails}
        // delete details.customerDetails
        details.orders = this.orders.map(item => ({sku: item.sku, name: item.name, qty: parseInt(item.qty, 10), price: Number(item.price.replace(',', '.'))}))

        await this.axios.put(`/api/wholesale/orders/${this.id}`, {...details, state: "invoice_input"})

        this.$store.commit("deleteCache", { include: "wholesale" })
        this.$router.push("/admin/wholesale-orders?state=invoice_input&refresh=true").catch(()=>{})
        this.$success("Factuur aangemaakt!")
      })
    },
    async deleteInvoice() {
      await this.$handlePromise(async () => {
        await this.axios.delete(`/api/wholesale/orders/${this.id}`)

        this.$router.push("/admin/wholesale-orders?state=invoice_input&refresh=true").catch(()=>{})
        this.$success("Factuur verwijderd!")
      })
    },
    async removeOrder(index) {
      const orders = this.orders.slice()
      orders.splice(index, 1)

      await this.$handlePromise(async () => {
        await this.axios.put(`/api/orders/${this.id}`, {
          ...this.orderDetails,

          orders,
        })

        this.$success("Een bestelling verwijderd!")
        await this.load()
      })
    },
    async save() {
      await this.$handlePromise(async () => {
        const details = {...this.orderDetails}
        // delete details.customerDetails
        details.orders = this.orders.map(item => ({sku: item.sku, name: item.name, qty: parseInt(item.qty, 10), price: item.price}))
        details.orders = details.orders.map(({ price, ...rest }) => (
        { ...rest, price: typeof price == 'string' ? Number(price.replace(",", ".")) : price }
        ))

        console.log(details.orders, 'details.orders')

        this.$store.commit("deleteCache", { include: "wholesale" })
        await this.axios.put(`/api/wholesale/orders/${this.id}`, details)
        this.$success("Bestelling bijgewerkt!")
      })
    },
  },
  computed: {
    canBeEdited() {
      return !this.isInvoice && this.isAdmin
    },
    columns() {
      return ["Naam", "Prijs", "Hoeveelheid", "Aantal dozen", "Colli", "SKU"]
    },
    variables() {
      return ["name", "price", "qty", "boxes", "colli", "sku"]
    },
    isAdmin() {
      return this.$store.state.user.role === 'ADMIN'
    },
    isInvoice() {
      return this.state === "invoice_input"
    },
    orderDetails() {
      return {
        ...fields.reduce((obj, key) => ({
          ...obj,
          [key]: this.$v[key].$model,
        }), {}),

        customerDetails: {
          ...customerDetails.reduce((obj, key) => ({
            ...obj,
            [key]: this.$v.customerDetails[key].$model,
          }), {}),
        },
      }
    },

    id() {
      return this.$route.params.id
    },
    ordersWithImages() {
      const images = this.orderImages
      return this.orders.map(item => ({...item, src: images[item.sku]}))
    },
    placeholderList() {
      const p = this.placeholder
      return [p,p,p,p,p,p]
    },
  },
}

</script>

<style>

.images-wrapper .card-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.OverviewOrderView .card-body {
  padding: 0px !important;
}

</style>

<style scoped>

.col-xl-9, .col-xl-3 {
  padding: 0;
}

.col-xl-3 {
  padding-top: 14px;
}

.sub-col {
  width: 100%;
}
.sub-col:nth-child(2) {
  margin-top: 8px;
  margin-bottom: 8px;
}

@media (min-width: 768px) {
  .sub-col {
    width: calc((100% / 2) - 2px);
  }

  .sub-col:nth-child(2) {
    margin-top: 0;
  }
}

.scroller {
  display: flex;
  height: 100%;
  position: relative;
  flex-wrap: nowrap;
  overflow: auto;
}

.images-wrapper {
  width: 100%;
}

.empty-state-wrapper {
  width: 100%;
}

.card-title {
  padding-bottom: 0px !important;
}

@media (min-width: 1200px) {
  .col-xl-3 {
    padding-top: 0;
    padding-left: 14px;
  }
}

</style>
